import PropTypes from 'prop-types';

import { HORIZONTAL_ALIGNMENT } from 'constants/ui';

export const ColumnDefShape = PropTypes.shape({
  label: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  isSort: PropTypes.bool,
  align: PropTypes.oneOf(Object.values(HORIZONTAL_ALIGNMENT)),
  style: PropTypes.object,
});
